import 'css/src/components/common/ui/MultiToggle.scss';

import React, { useCallback } from 'react';
import classNames from 'classnames';

import { BUTTON_SIZES, TertiaryButton } from 'js/src/components/common/ui/Button';

export type TypeMultiToggleItem = {
    key: string;
    value: string;
    testId?: string;
};
export type TypeMultiToggleProps = {
    items: Array<TypeMultiToggleItem>;
    onSelect: (item: string) => void;
    selectedItem?: string;
    disabled?: boolean;
    className?: string;
    textClassName?: string;
};

const MultiToggle: React.FC<TypeMultiToggleProps> = React.memo(function MultiToggle({
    items,
    onSelect,
    selectedItem,
    disabled,
    className,
    textClassName,
}) {
    const toggleItems = new Set(items);

    const handleToggle = useCallback(
        (itemKey: string) => {
            if (disabled) {
                return;
            }
            if (itemKey !== selectedItem) {
                onSelect(itemKey);
            }
        },
        [disabled, onSelect, selectedItem],
    );

    return (
        <div className="d-flex align-items-center">
            <div
                className={classNames(
                    'd-flex align-items-center toggle-select-group btn-rounded cursor-pointer p-l5-4',
                    { disabled: disabled },
                )}
                role="group"
                aria-label="Multi Toggle"
            >
                {[...toggleItems].map((item, index) => {
                    return (
                        <TertiaryButton
                            textClassName={textClassName}
                            key={index}
                            text={item.value}
                            className={classNames(className, {
                                active: item.key === selectedItem,
                            })}
                            size={BUTTON_SIZES.SM}
                            onClick={() => handleToggle(item.key)}
                            data-testid={item.testId}
                        />
                    );
                })}
            </div>
        </div>
    );
});

export default MultiToggle;
